<template>
  <generic-modal :title="$t('section assign')" ref="generic_modal">
    <form>
      <generic-dropdown
        :title="$t('select section')"
        :placeholder="$t('select section')"
        url="/student/section/catalog"
        name_field="name"
        value_field="section_id"
        @selected="set_section"
        ref="section_dropdown"
        :extra_data="{ program_id: key.program_id, stage_id: key.stage_id }"
        :is_multiple="false"
      />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "SectionAssignModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      key: {},
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.section_id ||
        !v.meta.inscription_list ||
        !v.meta.inscription_list.length
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(inscriptions, key) {
      let v = this;
      v.set_initial_state();
      v.key = JSON.parse(key);
      v.meta.inscription_list = inscriptions.map((i) => i.inscription_id);
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      post("/student/section/assign-students", {
        ...v.meta,
        program_id: v.key.program_id,
        stage_id: v.key.stage_id,
      })
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        // settings: {},
      };
      v.$refs.section_dropdown.clear();
      v.error = "";
      // v.uuid = "";
    },
    set_section(section) {
      let v = this;
      if (section) v.meta.section_id = section.section_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
